import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, onMessage, Messaging } from 'firebase/messaging';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {
  private messaging: Messaging;

  constructor(
    private router: Router,
    private userService: UserService,
  ) {
    const app = initializeApp(environment.firebaseConfig);
    this.messaging = getMessaging(app);
  }

  async getTokenIfPermitted(): Promise<string | null> {
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') {
      return null;
    }
    try {
      const token = await getToken(this.messaging, {
        vapidKey: environment.vapidKey
      });
      return token || null;
    } catch {
      return null;
    }
  }

  async getToken(): Promise<string | null> {
    try {
      const token = await getToken(this.messaging, {
        vapidKey: environment.vapidKey // You'll need to add this to your environment
      });
      if (token) {
        return token;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  listenForMessages(): void {
    onMessage(this.messaging, (payload) => {
      this.showNotification(payload);
    });
  }

  private showNotification(payload: any): void {
    const currentUser = this.userService.getCurrentUser();
    const payloadUserId = payload.data?.userId ? Number(payload.data.userId) : null;
    if (!payloadUserId || currentUser.id !== payloadUserId) {
      // Ignore notification not meant for this user
      return;
    }
    const notificationTitle = payload.notification?.title || 'New Message';
    const notificationBody = payload.notification?.body || '';
    const notificationOptions: any = {
      body: notificationBody,
      icon: environment.logo,
      requireInteraction: true,
      data: payload.data,
    };

    const notification = new Notification(notificationTitle, notificationOptions);
    notification.onclick = (event) => {
      event.preventDefault();

      if (notificationOptions.data && notificationOptions.data.url) {
        window.open(payload.data.url,'_self')
      }

      notification.close();
    };
  }
}
